import moment from "moment";
import { required } from "vuelidate/lib/validators";

export const MAX_RANGE_IN_MONTHS = 12

const maxMonthDiff = (maxMonths) => (value, vm) => {
  const startDate = moment(`${vm.startDate}-01`);
  const endDate = moment(`${value}-01`);
  return endDate.diff(startDate, "months") <= maxMonths;
};

export const RelatorioDREDataRequired = {
  startDate: {
    required,
  },
  endDate: {
    required,
    maxMonthDiff: maxMonthDiff(MAX_RANGE_IN_MONTHS),
  },
};
